// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TimerComponent_wrapper__3D4YL"};